const myProxy = Proxy as typeof MyProxy;
export default myProxy;
